import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/cod/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';

const {schema, initialValues} = bootstrapOldForm('Shipment Discharge', fields);

const ShipmentDischarge = props => {
    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Shipment &amp; Discharge
            </Typography>
            {[
                'date_shipment',
                'place_shipment',
                'date_detached',
                'place_discharge',
            ].map(field => (
                <AutoField
                    field={fields[field]}
                    name={`${field}`}
                    key={field}
                />
            ))}
            {props.children}
        </Section>
    );
};

export default ShipmentDischarge;
